import { MdFlag } from 'react-icons/md';
import { AlertDialog } from '@Components/AlertDialog/AlertDialog';
import { Intent } from '@Components/designConstants';

interface FlagConfirmationModalProps {
  show: boolean;
  // What's being flagged, e.g. "Media Inputs".
  title: string | null;
  onConfirm: () => void;
  onHide: () => void;
}

export const FlagConfirmationModal = ({
  show,
  title,
  onConfirm,
  onHide
}: FlagConfirmationModalProps) => (
  <AlertDialog
    show={show}
    onHide={onHide}
    intent={Intent.WARNING}
    icon={<MdFlag size={24} />}
    title={`Flag ${title ?? 'section'}?`}
    body='Flagging this section marks it as needing review before the model run can proceed. The run will be blocked until all flagged sections are resolved or re-approved.'
    primaryAction={{ onClick: onConfirm, label: 'Flag section' }}
    secondaryAction={{ onClick: onHide }}
  />
);
